module.exports = __webpack_public_path__ + "static/media/dub-3d.1fd65bdf.jpg";